import React, { Component } from "react";
import { connect } from "react-redux";
import { changeLanguage } from "../actions/actions-language";
import DropDown from "./dropdown";
import languages from "../languages.json";
import countries from "../countries.json";

export default connect(
    mapStateToProps,
    { changeLanguage }
)(
    class LanguageSelector extends Component {
        render() {
            const t = languages[this.props.language];
            return (
                <DropDown
                    label={t.language.title}
                    action={this.props.changeLanguage}
                    options={countries}
                    defaultValue={this.props.language}
                />
            );
        }
    }
);

function mapStateToProps(state) {
    return {
        language: state.reducerLanguage,
    };
}



// WEBPACK FOOTER //
// ./src/components/language-selector.js